module.exports = __webpack_public_path__ + "img/重庆九龙坡彩云湖国家湿地公园@2x.c5a7d2e4.png";